'use strict'

import { createElements, flatClick, getUrlParam, removePropParam, userPrevent } from '../../functions';
import { Buildings, isMobile, projectMode, settingsData } from '../../settings';
import {openOptionsCard} from "./optionsCards";
import {changeLangToCurrent} from "../language/langSwitcher";
import {ViewMode} from "../../common";
import {viewModesSwitching} from "../navigation/right-nav-bar";

export const createModal = () => {
    const bmbyPropID = getUrlParam('prop');

    let apartmentData;
    let crmApartmentData;
    let currentBuilding;

    crmApartmentData = settingsData.allCrmData.find(item => item.bmbyPropID === +bmbyPropID);



    if (crmApartmentData) {
        // currentBuilding =  buildings_info.find(building => building.name === crmApartmentData.buildingEngineId);
        currentBuilding =  Buildings.getBuilding(crmApartmentData.buildingEngineId);
        apartmentData = currentBuilding.apartments.find(item => item.userData.crm_data.bmbyPropID === +bmbyPropID);
        if (currentBuilding) {
            // currentBuilding.isActive = true;
            Buildings.activateBuilding(currentBuilding.name);
        }
    }

    if (!apartmentData) {
        for (let key in Buildings.buildings) {
            const customSelections = Buildings.buildings[key].customSelections
            customSelections.forEach((element) => {
                if (element.userData.name === bmbyPropID) {
                    apartmentData = element;
                    Buildings.activateBuilding(apartmentData.userData.crm_data.buildingEngineId);
                }
            })
        }
    }

    const aptExistText = 'propEnterPopup';
    const aptErrorText = 'Property does not exist';

    const aptExistButton = 'No';
    const aptErrorButton = 'Yes';


    const modal = createElements('div', ['modal__container', 'non-canvas'], document.body);
    const modalShade = createElements('div', ['modal__container-shade', 'non-canvas'], document.body);
    const modalWrapper = createElements('div', ['modal__container-wrapper', 'non-canvas'], modal);
    const text = createElements('div', ['modal__container-text', 'language-string'], modalWrapper);

    const buttonsBlock = createElements('div', ['modal__container-buttons-block', 'language-string'], modalWrapper);
    const closeButton = createElements('button', ['modal__container-close-btn', 'language-string', 'button'], buttonsBlock);

    if (apartmentData) {
        const button = createElements('button', ['modal__container-btn', 'button', 'language-string'], buttonsBlock);
        button.setAttribute('data-dictionary', 'Enter');
        button.innerHTML = changeLangToCurrent('Enter');
        button.setAttribute('data-menu-item', 'search');

        button.addEventListener('click', (e) => buttonClickHandler(e, apartmentData, crmApartmentData));
    }

    text.setAttribute('data-dictionary', apartmentData ? aptExistText : aptErrorText);
    closeButton.setAttribute('data-dictionary', apartmentData ? aptExistButton : aptErrorButton);

    text.innerHTML = changeLangToCurrent(apartmentData ? aptExistText : aptErrorText);
    closeButton.innerHTML = changeLangToCurrent(apartmentData ? aptExistButton : aptErrorButton);


    closeButton.addEventListener('click', closeBtnClickHandler);
}

const buttonClickHandler = async (e, apartmentData, crmApartmentData) => {
    document.querySelector('.modal__container').remove();
    document.querySelector('.modal__container-shade').remove();

    const activeBuilding = Buildings.getActiveBuilding();

    await projectMode.Cylinder.enter(activeBuilding);

    settingsData.lastClickedFlat = apartmentData;
    await flatClick(apartmentData);
    openOptionsCard();
}

const closeBtnClickHandler = () => {
    projectMode.Pagination.paginate({source: 'urlModalCloseButton'});

    document.querySelector('.modal__container-close-btn').removeEventListener('click', closeBtnClickHandler);
    document.querySelector('.modal__container').remove();
    document.querySelector('.modal__container-shade').remove();

    const activeBuilding = Buildings.getActiveBuilding();
    if (activeBuilding) {
        if (settingsData.activeViewMode !== ViewMode.Cylinder) {
            Buildings.deactivateBuilding();
        }
    }

    removePropParam();
}
